import { User } from './user.models';

export interface UserState {
	isAuthenticating: boolean;
	isAuthenticated: boolean;
	isCancelled: boolean;
	isCancellationSet: boolean;
	isPaid: boolean;
	mfaCode: string;
	mfaExpiration: Date | null;
	user: User | null;
	userToken?: string;
	uidToken?: string;
	utToken?: string;
	isSessionExpired: boolean;
	isLockoutAccess: boolean;
	orderTicketTypes?: OrderTicketType;
	guestViewOrderComplete?: boolean;
}

export const initialState: UserState = {
	isCancelled: false,
	isCancellationSet: false,
	isAuthenticating: false,
	isAuthenticated: false,
	isPaid: false,
	mfaCode: '',
	mfaExpiration: null,
	user: null,
	isSessionExpired: false,
	isLockoutAccess: false,
	orderTicketTypes: null,
};

export interface OrderTicketType {
	isPaymentPlan: boolean;
	isBookable: boolean;
	isLoqBookable: boolean;
	isMembership: boolean;
	isNewContractViewer: boolean;
}
